import { render, staticRenderFns } from "./candidateMangent.vue?vue&type=template&id=47755756&scoped=true"
import script from "./candidateMangent.vue?vue&type=script&lang=js"
export * from "./candidateMangent.vue?vue&type=script&lang=js"
import style0 from "./candidateMangent.vue?vue&type=style&index=0&id=47755756&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47755756",
  null
  
)

export default component.exports